import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onUpload", "use"],
  _excluded2 = ["isOver"];
import FileDragAndDrop from 'FileManagerCore/components/FileDragAndDrop';
import { DropZone } from 'foundations-components/transitional/components/DropZone';
import { jsx as _jsx } from "react/jsx-runtime";
const DropTargetZone = _ref => {
  let {
      children,
      onUpload,
      use
    } = _ref,
    dropZoneProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleDropFiles = files => {
    onUpload(files, {
      target: 'file-upload-drop-target'
    });
  };
  return /*#__PURE__*/_jsx(FileDragAndDrop, {
    onDropFiles: handleDropFiles,
    children: _ref2 => {
      let {
          isOver
        } = _ref2,
        props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
      return /*#__PURE__*/_jsx("div", Object.assign({
        "data-test-id": "drop-zone-target",
        "data-is-over": isOver
      }, props, {
        children: /*#__PURE__*/_jsx(DropZone, Object.assign({
          use: isOver ? 'hover' : use
        }, dropZoneProps, {
          "data-test-id": "file-upload-drop-target",
          children: children
        }))
      }));
    }
  });
};
export default DropTargetZone;